import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../../app/hooks';
import { initializeRecurringTask, updateRecurringTask } from '../state';

/**
 * useRecurringTaskPrefill - Initializes a new recurring task and pre-fills
 * fields from URL query params (e.g., when navigating from asset page).
 * Supported params: category, assetId, assetTag, assetName, centerId
 */
export const useRecurringTaskPrefill = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    dispatch(initializeRecurringTask());

    const category = searchParams.get('category');
    const assetId = searchParams.get('assetId');
    const assetTag = searchParams.get('assetTag');
    const assetName = searchParams.get('assetName');
    const centerId = searchParams.get('centerId');

    if (category) {
      dispatch(updateRecurringTask({ category }));
    }
    if (category === 'PM' && assetId) {
      dispatch(updateRecurringTask({
        preventiveMaintenanceRequest: {
          centerId: centerId || '',
          assetId,
          assetTag: assetTag || '',
          assetName: assetName || '',
        },
      }));
    }
  }, [dispatch, searchParams]);
};
